import * as React from "react";
import { IControlSchema } from "../../core/Controls";
import { IDispatcher } from "../helpers/Dispatcher";

interface TotalHeaderSchema extends IControlSchema {
	elements: Array<string>;
}

interface Props {
	schema: TotalHeaderSchema;
	api: any;
	dispatcher: IDispatcher;

	values: Array<{
		controlid: string;
		value: any;
	}>;
}

class TotalHeader extends React.Component<Props> {
	render() {
		const {
			values,
			schema: { title, elements },
		} = this.props;
		let total = 0;

		for (const control of values) {
			for (const el of elements) {
				if (control.controlid.indexOf(el as string) === 0) {
					total += parseFloat(control.value);
				}
			}
		}

		return (
			<div className="text-right">
				<h3>
					{title.ru} {total.toFixed(2)}
				</h3>
			</div>
		);
	}
}

export function createTotalHeader(
	schema: IControlSchema,
	api: any,
	dispatcher: IDispatcher = null,
	values: any
) {
	return (
		<TotalHeader schema={schema as TotalHeaderSchema} api={api} dispatcher={dispatcher} values={values} />
	);
}
